export const itemDropdownAcara = [
  {
    text: "Acara Terbaru",
    value: 0,
  },
  {
    text: "Acara Terdahulu",
    value: 1,
  },
];

export const itemDropdownBerita = [
  {
    text: "Berita Terbaru",
    value: 0,
  },
  {
    text: "Berita Terdahulu",
    value: 1,
  },
];

export const itemDropdownArtikel = [
  {
    text: "Artikel Terbaru",
    value: 0,
  },
  {
    text: "Artikel Terdahulu",
    value: 1,
  },
];

export const itemDropdownBuletin = [
  {
    text: "Buletin Terbaru",
    value: 0,
  },
  {
    text: "Buletin Terdahulu",
    value: 1,
  },
];
